import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import ReactRouterPropTypes from 'react-router-prop-types'
import useGetConfigurator from 'core/hooks/useGetConfigurator'
import * as routes from 'core/routing/constants/index'
import wizardsShape from 'core/components/wizard/shapes'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import styled from 'styled-components'
import { Row, ButtonPrev, Empty } from 'core/components/ui'
import PageLoading from 'core/components/page-loading'

import BrandItem from './brand-item'
//import configurationShape from '../../configuration/shapes'
import { configuratorShape } from '../shapes'

const BrandWrapper = styled(Row)``
const BackToHomeWrapper = styled.div`
  margin-bottom: 20px;
`

const renderList = brandsList =>
  brandsList.map(brand => (
    <BrandItem brand={brand} key={brand.name} data-test="configurator-brands-list-brand-item" />
  ))

const BrandsList = props => {
  const { history, intl, configurator, setConfigurator, wizards } = props
  const { brandsList } = configurator
  const { loading, getMakes, makes } = useGetConfigurator({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })
  const deleteConfiguration = () => {
    getMakes()
  }

  useEffect(() => {
    const runIt = list => {
      setConfigurator({
        ...configurator,
        brandsList: list
      })
    }

    if (makes) runIt(makes)
  }, [makes])

  useEffect(() => {
    // Redirection if direct access & step is not active

    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.CONFIGURATOR_BRANDS
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    deleteConfiguration()
  }, [])

  return (
    <MainContentWrapper
      title={intl.formatMessage({ id: 'configurator-brands-view-title' })}
      data-test="component-configurator-brands-list"
    >
      <BackToHomeWrapper>
        <ButtonPrev
          onClick={() => history.push(routes.HOME)}
          data-test="configurator-brands-list-back-button"
        >
          <FormattedMessage id="ui-button-back" />
        </ButtonPrev>
      </BackToHomeWrapper>
      {loading ? (
        <PageLoading data-test="configurator-brands-list-loading" />
      ) : (
        <BrandWrapper
          type="flex"
          justify="center"
          align="middle"
          gutter={16}
          data-test="configurator-brands-list-brand-wrapper"
        >
          {brandsList ? renderList(brandsList) : <Empty />}
        </BrandWrapper>
      )}
    </MainContentWrapper>
  )
}

BrandsList.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  intl: PropTypes.shape().isRequired,
  wizards: wizardsShape.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
  //configuration: configurationShape.isRequired
}

export default withRouter(injectIntl(BrandsList))
